import { render, staticRenderFns } from "./compManageDevelop.vue?vue&type=template&id=57be1b30&scoped=true"
import script from "./compManageDevelop.vue?vue&type=script&lang=js"
export * from "./compManageDevelop.vue?vue&type=script&lang=js"
import style0 from "./compManageDevelop.vue?vue&type=style&index=0&id=57be1b30&prod&lang=scss&scoped=true"
import style1 from "./compManageDevelop.vue?vue&type=style&index=1&id=57be1b30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57be1b30",
  null
  
)

export default component.exports